// extracted by mini-css-extract-plugin
export default {"modalContent":"Memorandom__modalContent--sfLYZ","customModal":"Memorandom__customModal--3ieIA","submitBtn":"Memorandom__submitBtn--A7R3v"};